module.exports = __webpack_public_path__ + "img/2.bdfda6a3.jpg";